/**
 * 数字のみの文字列かどうかを判定
 * → true: DB に登録されたカテゴリの ID（"1", "42", …）
 */
export function isPersistedId(id: string): boolean {
    // UUID には必ずハイフンが含まれるので、
    // ハイフンがない＝数字IDとみなす
    return !id.includes("-");
}
